import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('select_subscription'),
    emptySubscriptions: defineMessage('there_are_no_applicable_subscriptions'),
    otherOptions: defineMessage('other_options'),
    newSubscriptionOption: defineMessage('add_this_organisation_to_new_subscription'),
    newTrialOptionForPartner: defineMessage('create_a_new_organisati__the_subscription_later'),
    newTrialOptionForEndUser: defineMessage('start_with_three_days_f_to_a_subscription_later'),
    confirm: defineMessage('confirm'),
    subscriptionsTitle: defineMessage('please_select_which_sub__the_subscription_first'),
    subscriptionNameMore: defineMessage('freeslots_more_organisa_an_be_added_upgradetext'),
    upgraded: defineMessage('can_be_upgraded'),
    upgradePanelMessage: defineMessage('this_will_upgrade_your__r_do_a_prorated_upgrade'),
    upgradePanelMessageAmount: defineMessage('your_new_monthly_billin__amountstr_before_taxes'),
    confirmText: defineMessage('i_understand_that_the_checkout_will_be_skipped'),
};
